if (!customElements.get("search-bar")) {
  class SearchBar extends HTMLElement {
    static OPEN_CLASS = "is-open";

    constructor() {
      super();

      this.handleToggleRef = this.#handleToggle.bind(this);
      this.handleCloseRef = this.#handleClose.bind(this);
    }

    #handleToggle() {
      this.classList.toggle(SearchBar.OPEN_CLASS);

      if(!this.classList.contains(SearchBar.OPEN_CLASS)) return;

      this.querySelector('input[name="q"]')?.focus();
    }

    #handleClose() {
      this.classList.remove(SearchBar.OPEN_CLASS);
    }

    disconnectedCallback() {
      document.removeEventListener("search:toggle", this.handleToggleRef);
      
      document.body.removeEventListener('click', this.handleCloseRef);
      window.removeEventListener('resize', this.handleCloseRef);
    }

    connectedCallback() {
      document.addEventListener("search:toggle", this.handleToggleRef);
      this.addEventListener('click', event => event.stopPropagation());

      document.body.addEventListener('click', this.handleCloseRef);
      window.addEventListener('resize', this.handleCloseRef);
    }
  }

  customElements.define("search-bar", SearchBar);
}
